/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import UpdateAxios from "../../axiosComponent/update";
import CreateAxios from "../../axiosComponent/create";
import { DateData } from "../../dynamicComponent/datepick";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { setHours, setMinutes, format } from 'date-fns';
import moment from 'moment';
import 'moment-timezone';
import { translate } from "react-i18next";
import cogoToast from "cogo-toast";

const ModalVehicle = ({ values, isSubmitting, handleSubmit, setFieldValue, t, props, delivery_status, delivery_details, delivery_text, movement_type }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [deliverStatus, setdeliverStatus] = useState(0);
  const [prevDate, setprevDate] = useState(0)

  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setmodalOpen(false);
    setprevDate(values.actual_pickup_date)
    console.log("date check : ", prevDate);
    if (values.actual_pickup_date) handleSubmit();
  };


  // let d1 = delivery_status == "PCKDUP" ? new Date(delivery_details.actual_pickup_date) : (delivery_status == "DLVRD" ? new Date(delivery_details.actual_delivery_date) : null)
  // let compareDate;
  // if (d1) {
  //   console.log("D1", d1);
  //   compareDate = d1 ? true : false
  //   console.log("comparedate", compareDate);
  // }


  return (
    <div>
      <Modal
        style={{ overflow: "inherit" }}
        open={modalOpen}
        onClose={handleClose}
        size="mini"
        trigger={
          <Button
            basic
            type="button"
            onClick={handleOpen}
            size="mini"
            color="blue"
            className="p-bold-600 mr-2"
            // disabled={delivery_text == "Dropped" ? "true" : "false"}
            disabled={delivery_status == "DLVRD" && (movement_type == "Primary" || movement_type == "Primário")
              ? true : (delivery_status == "DROPPED" && (movement_type == "Import" || movement_type == "Importar") ? true : false)}
          >
            {/* {delivery_text == "NA" ? "PickUp" : deliverStatus} */}
            {delivery_status != "NA" ? (delivery_status == "PCKDUP" ? t("deliver") || "Deliver" : (delivery_status == "DLVRD" && (movement_type == "Primary" || movement_type == "Primário") ? t("Delivered") || "Delivered" : (delivery_status == "DLVRD" && (movement_type == "Import" || movement_type == "Importar") ? t("Drop") || "Drop" : t("Dropped") || "Dropped"))) : t("pick up") || "Pickup"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="mt-2 font-weight-normal">{delivery_status != "NA" ? (delivery_status == "PCKDUP" ? t("deliver") || "Deliver" : (delivery_status == "DLVRD" ? t("Drop") || "Drop" : t("Dropped") || "Dropped")) : t("pick up") || "Pickup"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <div className="ui form">
              <FormUi.Field>
                <label className="labelName"> {delivery_status != "NA" ? (delivery_status == "PCKDUP" ? t("deliver") || "Deliver" : (delivery_status == "DLVRD" ? t("Drop") || "Drop" : t("Dropped") || "Dropped")) : t("pick up") || "Pickup"} {t("Date_time") || "Date & Time"}</label>
              </FormUi.Field>
              <FormUi.Field>
                <DateData
                  name="actual_pickup_date"
                  autoComplete="off"
                  showTimeSelect
                  timeFormat="HH:mm"
                  popperClassName="dateTime"
                  dateFormat="dd/MM/yyyy HH:mm"
                  minDate={delivery_status == "PCKDUP" ? new Date(delivery_details.actual_pickup_date) : (delivery_status == "DLVRD" ? new Date(delivery_details.actual_delivery_date) : 'NA')}
                  timeIntervals={5}
                  maxDate={new Date()}
                  // minTime={setHours(setMinutes(new Date(), 0), 0)}
                  // maxTime={setHours(setMinutes(new Date(), compareDate ? new Date().getMinutes() : 59), compareDate ? new Date().getHours() : 23)}
                  customInput={
                    <FormUi.Input
                      icon="time"
                      className="dateWidth"
                      iconPosition="left"
                    />
                  }
                />
              </FormUi.Field>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={isSubmitting || values.actual_pickup_date ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikPickup = withFormik({
  mapPropsToValues() {
    return {
      actual_pickup_date: new Date()
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    let URL = ""
    if (props.delivery_status == "NA") {
      values.actual_pickup_date = moment.parseZone(values.actual_pickup_date).format('YYYY-MM-DD HH:mm')
      URL = `${process.env.REACT_APP_TA_API_URL}/deliveries/${props.delivery_id}/pickup`
    }
    else if (props.delivery_status == "PCKDUP") {
      if (moment.parseZone(values.actual_pickup_date).format('YYYY-MM-DD HH:mm') < moment.parseZone(props.delivery_details.actual_pickup_date).format('YYYY-MM-DD HH:mm')) {
        console.log("in if");
        cogoToast.error("Selected time less than actual pickup time")
        setSubmitting(false)
      }
      else {
        values.actual_delivery_date = moment.parseZone(values.actual_pickup_date).format('YYYY-MM-DD HH:mm')
        URL = `${process.env.REACT_APP_TA_API_URL}/deliveries/${props.delivery_id}/delivered`
      }
    }
    else if (props.delivery_status == "DLVRD" && (props.movement_type == "Import" || props.movement_type == "Importar")) {
      if (moment.parseZone(values.actual_pickup_date).format('YYYY-MM-DD HH:mm') < moment.parseZone(props.delivery_details.actual_delivery_date).format('YYYY-MM-DD HH:mm')) {
        cogoToast.error("Selected time less than actual delivery time")
        setSubmitting(false)
      }
      else {
        values.actual_container_return_date = moment.parseZone(values.actual_pickup_date).format('YYYY-MM-DD HH:mm')
        URL = `${process.env.REACT_APP_TA_API_URL}/deliveries/${props.delivery_id}/drop`
      }
    }

    UpdateAxios({
      patchURL: URL, payload: values,
    })
      .then((res) => {
        setSubmitting(false);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        // props.reFetchOrder();
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
  },

})(ModalVehicle);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikPickup)
);
